import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';

import { useUser } from '@/modules/auth/hooks';
import { ALL_USERS_GROUP_ID } from '@/modules/groups';

import { useIsViewingAsOther } from '../../hooks/useIsViewingAsOther';
import { useViewFilter } from '../../hooks/useViewFilter';
import { assignedToMeViewFilter } from '../../utilities/assignedToMeViewFilter';
import * as felaRules from './ViewingAsPill.rules';

interface ViewingAsPillProps {
    className?: string;
}

export const ViewingAsPill = ({ className }: ViewingAsPillProps) => {
    const { css } = useFela();
    const intl = useIntl();
    const user = useUser();
    const isViewingAsOther = useIsViewingAsOther();
    const { viewFilter, setView } = useViewFilter();

    if (!isViewingAsOther || viewFilter === null) {
        return null;
    }

    const targetName = viewFilter.id === ALL_USERS_GROUP_ID ? intl.formatMessage({ id: 'secret.groups.allUsers.label' }) : viewFilter.name;

    const stopViewingAs = () => {
        setView(user ? assignedToMeViewFilter(user) : null);
    };

    return (
        <div className={css(felaRules.pill, className)}>
            <span className={css(felaRules.label)}>
                <FormattedMessage id='sidebar.viewingAs' values={{ name: targetName }} />
            </span>
            <button type='button' className={css(felaRules.stopButton)} onClick={stopViewingAs}>
                <FormattedMessage id='sidebar.viewingAsStop' />
            </button>
        </div>
    );
};
